import { kubernetesLiveUsageMgmtSliceSelector } from "./kubernetesLiveUsageMgmtSliceSelector";
import { RootState } from "../../../store";
import { KubernetesLiveUsagePageStateType } from "../../utils/types";

export const kubernetesLiveUsagePageStateSelector = (
  state: RootState,
): KubernetesLiveUsagePageStateType =>
  kubernetesLiveUsageMgmtSliceSelector(state).state;
